import PersonSVG from '../../assets/svg/person-solid.svg';
export default PersonSVG;
